import { render, staticRenderFns } from "./ZoomMainClientPage.vue?vue&type=template&id=47c1bdfe&scoped=true&"
import script from "./ZoomMainClientPage.vue?vue&type=script&lang=js&"
export * from "./ZoomMainClientPage.vue?vue&type=script&lang=js&"
import style0 from "./ZoomMainClientPage.vue?vue&type=style&index=0&id=47c1bdfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c1bdfe",
  null
  
)

export default component.exports